//import {format} from 'date-fns'

export const COLUMNS = [
    {
        Header: 'ID',
        accessor: 'user_id'
    },
    {
        Header: 'Instructor Name',
        accessor: 'full_name'
    }
]